export const WEBSITE_PRIVACY_COOKIE_NAME = 'TC_PRIVACY_CENTER';
export const WEBSITE_TRACKING_CONSENT_VALUE = '2';
